import ChatHero from './ChatHero';

export default ChatHero;
